import React, {useEffect, useState} from "react";
import { useSelector } from "react-redux";
import produto from "../../assets/produto.png";
import motoImage from "../../assets/ProductImages/Premios-Avanti-PNG-moto.png";
import carroImage from "../../assets/ProductImages/Premios-Avanti-PNG-carro.png";
import apartamentoImage from "../../assets/ProductImages/Premios-Avanti-PNG-Apartamento.png";
import smartphoneImage from "../../assets/ProductImages/Premios-Avanti-PNG-celular.png";
import TVImage from "../../assets/ProductImages/Premios-Avanti-PNG-TV.png";

import HeaderBannerHome from "../../components/HeaderBannerHome/index";
import SimpleSlider from "../../components/SimpleSlider/index";
import Footer from "../../components/Footer/index";
import Raffles from "../../components/Raffles/index";
import AdvertisingCard from "../../components/AdvertisingCard/index";
import InfoAvantiCard from "../../components/InfoAvantiCard/index";
import ModalPoints from "../../components/ModalPoints/index";
import {
    Container,
    StyledTitle,
    StyledDescription,
    ButtonContainer,
    CustomButton,
    CardsContainer,
    ContentHeader,
    ContentWrapper,
    StyledHomeContent
} from "../../components/HomeTab/styles";
import { advertisingCardsData } from "../../utils/consts";
const HomeContent = (props) => {
  const { config } = useSelector((state) => state.global);
  const { rafflesData, rafflesLuckyNumbers } = useSelector((state) => state.raffles);
  const { userData } = useSelector((state) => state.user);
  const { userHelper, message, dataHelper } = config;
  const [allLoyaltyTypes, setAllLoyaltyTypes] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentProducts, setCurrentProducts] = useState([]);

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };
  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const loadCurrentRaffleData = async () => {
    const { Products__r } = rafflesData;
    const products = Products__r?.records
      .reduce((acc, product) => {
      if (!acc.some(p => p.Name === product.Name)) {
        acc.push(product);
      }
      return acc;
      }, [])
      .sort((a, b) => a.Order__c - b.Order__c);
    setCurrentProducts(products || []);
  }

  useEffect(() => {
    const fetchData = async () => {
      await loadCurrentRaffleData();
      if(userData && Object.keys(userData).length > 0){
      const loyaltyType = await userHelper.getAllLoyaltyType(null, true);
      setAllLoyaltyTypes(loyaltyType)
      }
    };
    fetchData();
  }, [rafflesData]);

  return (
    <StyledHomeContent>
      <HeaderBannerHome />
      <ContentWrapper>
        <SimpleSlider data={currentProducts} />
        {userData && Object.keys(userData).length > 0 ? (
          <InfoAvantiCard
            userName={userData?.FirstName + " " + userData?.LastName || ""}
            planName={userData?.LoyaltyCategory__c || ""}
            totalLuckyNumbers={rafflesLuckyNumbers?.length || 0}
            onChangeTab={props?.onChangeTab}
          />
        ) : (
          <InfoAvantiCard
            isAvanti={true} 
          />
        )}
        <ContentHeader>
          <StyledTitle>
            QUANTO MAIS PALMEIRAS MAIS CHANCES DE GANHAR
          </StyledTitle>
          <StyledDescription>
            Existem três formas de aumentar suas chances nos sorteios:
          </StyledDescription>
        </ContentHeader>
        <CardsContainer>
          {advertisingCardsData?.map((card, index) => (
            <AdvertisingCard allLoyaltyTypes={allLoyaltyTypes} userData={userData} key={index} {...card} handleModalOpen={handleModalOpen} />
          ))}
        </CardsContainer>
        <ButtonContainer>
          <CustomButton onClick={() => props?.onChangeTab("Regulamento")}>consulte o regulamento</CustomButton>
        </ButtonContainer>
      </ContentWrapper>
      <Raffles onChangeTab={props.onChangeTab} />
      <Footer />
      {isModalOpen && (
        <ModalPoints onClose={() => handleModalClose(false)} />
      )}
    </StyledHomeContent>
  );
};

export const HomeTab = (props) => {
  return (
    <Container>
      <HomeContent onChangeTab={props?.onChangeTab} />
    </Container>
  );
};

export default HomeTab;
